import React from "react";
import MeetingDetails from "./MeetingDetails";

const ViewMeeting = () => {
  return <MeetingDetails />;
};
export default ViewMeeting;
